var map = {
	"./locale-provider/de_DE.tsx": 720,
	"./locale-provider/en_US.tsx": 721,
	"./locale-provider/es_ES.tsx": 722,
	"./locale-provider/fr_BE.tsx": 723,
	"./locale-provider/pt_BR.tsx": 724,
	"./locale-provider/ru_RU.tsx": 725,
	"./locale-provider/sv_SE.tsx": 727
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 687;



/*****************
 ** WEBPACK FOOTER
 ** ./components ^\.\/locale-provider\/.+_.+\.tsx$
 ** module id = 687
 ** module chunks = 1
 **/